export const TENANT_ROLE = {
  ADMIN: 'TENANT_ADMIN',
  CONTENT: 'TENANT_CONTENT',
  MEMBER: 'TENANT_USER',
} as const;

export type TenantRoleType = (typeof TENANT_ROLE)[keyof typeof TENANT_ROLE];
